import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBAndRautomationComponent } from './simple-icons-b-and-rautomation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBAndRautomationComponent ],
    exports:      [ SimpleIconsBAndRautomationComponent ],
    bootstrap:    []
})
export class SimpleIconsBAndRautomationModule {}
